import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretUp = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.4573 10.2546C18.863 8.8489 21.1458 8.8489 22.5514 10.2546L36.9454 24.6486C37.98 25.6831 38.2836 27.2237 37.7214 28.5732C37.1591 29.9226 35.8546 30.7997 34.3928 30.7997L5.60476 30.7997C4.15412 30.7997 2.83841 29.9226 2.27615 28.5732C1.71388 27.2237 2.02875 25.6831 3.05207 24.6486L17.4461 10.2546H17.4573Z" })
});
export default SvgCaretUp;
